import axios from 'axios'
import { Toast } from 'vant'
import { normalizeSniResponseCode } from '@/utils/sni-response'
import { clearSniSession } from '@/utils/sni-session'

let redirectingToLogin = false

function redirectToAromaLogin () {
  if (typeof window === 'undefined') return false
  if (redirectingToLogin) return true

  const currentUrl = new URL(window.location.href)
  const sn = currentUrl.searchParams.get('sn') || ''
  clearSniSession(sn)

  if (currentUrl.pathname === '/aroma-report/login') return false

  const loginUrl = new URL('/aroma-report/login', currentUrl.origin)
  if (sn) loginUrl.searchParams.set('sn', sn)

  const redirect = currentUrl.pathname === '/aroma-report/profile'
    ? currentUrl.searchParams.get('redirect') || ''
    : `${currentUrl.pathname}${currentUrl.search}${currentUrl.hash}`
  if (redirect) loginUrl.searchParams.set('redirect', redirect)

  redirectingToLogin = true
  window.location.replace(loginUrl.toString())
  return true
}

const service = axios.create({
  baseURL: process.env.VUE_APP_SNI_API_URI,
  withCredentials: false,
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json'
  }
})

service.interceptors.request.use(
  config => {
    Toast.loading({
      loadingType: 'spinner'
    })
    return config
  },
  error => Promise.reject(error)
)

service.interceptors.response.use(
  response => {
    Toast.clear()
    const responseData = response.data || {}
    const responseCode = normalizeSniResponseCode(responseData.code)
    if (responseCode === '1') {
      return Promise.resolve(responseData.data)
    }

    if (responseCode === '11' && redirectToAromaLogin()) {
      return new Promise(() => {})
    }

    const error = new Error(responseData.msg || '请求失败')
    error.code = responseCode
    error.responseData = responseData
    return Promise.reject(error)
  },
  error => {
    Toast.clear()
    const message = error?.message || '网络异常'
    Toast(message)
    return Promise.reject(error)
  }
)

export const sniHttp = {
  post (url, data, config) {
    return service.post(url, data, config)
  }
}

export default service
